/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Services_LabelInputs */

const en_candidate_profile_services_label = /** @type {(inputs: Candidate_Profile_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Services/Products`)
};

const de_candidate_profile_services_label = /** @type {(inputs: Candidate_Profile_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugte Dienstleistungen/Produkte`)
};

/**
* | output |
* | --- |
* | "Preferred Services/Products" |
*
* @param {Candidate_Profile_Services_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_services_label = /** @type {((inputs?: Candidate_Profile_Services_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Services_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_services_label(inputs)
	return en_candidate_profile_services_label(inputs)
});